export default __webpack_public_path__ + "img/e25ba9861cd79b24425d2b406f81c4ef.png";